import React from 'react';
import Header from '../../components/Header/Header';
import PageBanner from '../../components/PageBanner/PageBanner';
import FAQSection from '../../components/FAQSection/FAQSection';
import Footer from '../../components/Footer/Footer';
import './FAQPage.css';

const FAQPage: React.FC = () => {
    return (
        <div className="faq-page">
            <Header />
            <PageBanner
                badge="FAQS"
                title="Frequently Asked Questions"
                backgroundImage={require('../../assets/images/hero-bg1.jpg')}
                breadcrumbs={[
                    { label: 'Advocate Kannan', path: '/' },
                    { label: 'Resources', path: '/blog' },
                    { label: 'FAQs' }
                ]}
            />

            <main className="faq-page-content">
                <FAQSection />
            </main>

            <Footer />
        </div>
    );
};

export default FAQPage;
